import React from 'react';
import Modal from '../components/Modal';
import { useTranslation } from 'react-i18next';

type RoscCheckListDialogProps = {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const RoscCheckListDialog: React.FC<RoscCheckListDialogProps> = ({ isOpen, setIsOpen }) => {
  const { t } = useTranslation(['resus']);
  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={t('roscChecklist.title')}
      direction="rtl"
    >
      <div className="text-right space-y-4">
        <section>
          <h5 className="font-bold mb-2">{t('roscChecklist.oxygenationTitle')}</h5>
          <ul className="list-disc mr-6 space-y-1">
            <li>{t('roscChecklist.oxygenationItem1')}</li>
            <li>{t('roscChecklist.oxygenationItem2')}</li>
            <li>{t('roscChecklist.oxygenationItem3')}</li>
            <li>{t('roscChecklist.oxygenationItem4')}</li>
            <li>{t('roscChecklist.oxygenationItem5')}</li>
          </ul>
        </section>

        <section>
          <h5 className="font-bold mb-2">{t('roscChecklist.hemodynamicTitle')}</h5>
          <ul className="list-disc mr-6 space-y-1">
            <li>{t('roscChecklist.hemodynamicItem1')}</li>
            <li>{t('roscChecklist.hemodynamicItem2')}</li>
            <li>{t('roscChecklist.hemodynamicItem3')}</li>
          </ul>
        </section>

        <section>
          <h5 className="font-bold mb-2">{t('roscChecklist.neurologicalTitle')}</h5>
          <ul className="list-disc mr-6 space-y-1">
            <li>{t('roscChecklist.neurologicalItem1')}</li>
            <li>{t('roscChecklist.neurologicalItem2')}</li>
          </ul>
        </section>

        <section>
          <h5 className="font-bold mb-2">{t('roscChecklist.temperatureTitle')}</h5>
          <ul className="list-disc mr-6 space-y-1">
            <li>{t('roscChecklist.temperatureItem1')}</li>
            <li>{t('roscChecklist.temperatureItem2')}</li>
            <li>{t('roscChecklist.temperatureItem3')}</li>
            <li>{t('roscChecklist.temperatureItem4')}</li>
          </ul>
        </section>

        <section>
          <h5 className="font-bold mb-2">{t('roscChecklist.electrolytesTitle')}</h5>
          <ul className="list-disc mr-6 space-y-1">
            <li>{t('roscChecklist.electrolytesItem1')}</li>
            <li>{t('roscChecklist.electrolytesItem2')}</li>
          </ul>
        </section>

        <section>
          <h5 className="font-bold mb-2">{t('roscChecklist.actionsTitle')}</h5>
          <ul className="list-disc mr-6 space-y-1">
            <li>{t('roscChecklist.actionsItem1')}</li>
            <li>{t('roscChecklist.actionsItem2')}</li>
            <li>{t('roscChecklist.actionsItem3')}</li>
          </ul>
        </section>

        <section>
          <h5 className="font-bold mb-2">{t('roscChecklist.transferTitle')}</h5>
          <ul className="list-disc mr-6 space-y-1">
            <li>{t('roscChecklist.transferItem1')}</li>
            <li>{t('roscChecklist.transferItem2')}</li>
          </ul>
        </section>
      </div>
    </Modal>
  );
};

export default RoscCheckListDialog;
